<template>
  <div class="subject">
    <div class="content">
<!--      <div class="tit">1-1上课注意事项直播试题</div>-->
      <li v-for="(item,index) in subjects.list" :key="index">
        <div class="top">{{item.nub}}.{{item.title}} (
          <span v-if="item.type === 1">单选</span>
          <span v-if="item.type === 2">多选 </span>
          <span v-if="item.type === 3">文本输入</span>
          <span v-if="item.type === 4">上传文件</span>
          )
        </div>

        <div v-if="item.type === 1" class="radio">
          <div class="label supportTbody" v-for="(items, indexs) in item.option" :key="indexs">
            <div @click="answerRadio(index,items.test_id,items.id)">
              <label :for="'radio' + items.test_id + indexs">
                <input :id="'radio' + items.test_id + indexs" type="radio" :name="'radio' + items.test_id"
                       :value="items.id"/>
                <i></i>
                <span>{{items.name}}</span>
                <b>{{items.describe}}</b>
              </label>
            </div>
          </div>
        </div>

        <div v-if="item.type === 2" class="checkbox">
          <div class="label supportTbody" v-for="(items, indexs) in item.option" :key="indexs">
            <div @click="answerCheckbox(index,indexs,items.test_id,items.id,$event)">
              <label :for="'radio' + items.test_id + indexs">
                <input :class="'radio' + items.test_id + indexs" :id="'radio' + items.test_id + indexs" type="checkbox"
                       :name="'radio' + items.test_id"
                       :value="items.id"/>
                <i>✓</i>
                <span>{{items.name}}</span>
                <b>{{items.describe}}</b>
              </label>
            </div>
          </div>
        </div>

        <div v-if="item.type === 3" class="textarea">
          <textarea @input="descInput(index,item.id,$event)" placeholder="请输入内容"></textarea>
        </div>

        <div v-if="item.type === 4" class="file">
          <input type="file" class="upload" multiple="multiple" @change="addImg(index,item.id)" id="upload-ele"/>
        </div>

      </li>
      <div @click="addtest" class="sure">提交</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      subjects: {
        type: Object
      }
    },
    data () {
      return {
        answer: [],
        id: 0,
        timer: null
      }
    },
    destroyed () {
      this.$http.post('/apipx/Lesson/studyrecord', {
        lesson_id: this.id,
        time_lenght: this.htmlTime,
        num: 0,
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        clearInterval(this.timer)
      })
    },
    created () {
      this.id = this.$parent.id
      this.timer = setInterval(res => {
        this.htmlTime++
      }, 1000)
      for (let i = 0; i < this.subjects.list.length; i++) {
        var val
        if (this.subjects.list[i].type === 2) {
          val = []
        } else if (this.subjects.list[i].type === 1) {
          val = []
        } else {
          val = ''
        }
        this.answer.push({
          key: '',
          val: val
        })
      }
    },
    methods: {
      answerRadio (index, testId, id) {
        this.answer[index].val[0] = id
        this.answer[index].key = testId
      },
      answerCheckbox (index, indexs, testId, id, $event) {
        let as = this.answer[index].val
        if ($event.target.checked) {
          as[indexs] = id
          this.answer[index].val = as
          this.answer[index].key = testId
        } else {
          this.answer[index].val[indexs] = ''
        }
      },
      addImg (index, id) { // 上传文件
        let file = document.getElementById('upload-ele').files[0]
        let config = {
          headers: {'Content-Type': 'multipart/form-data'}
        }
        let formData = new FormData()
        formData.append('type', 'image')
        formData.append('group', 'user')
        formData.append('method', 'post')
        formData.append('file', file)
        const that = this
        formData.append('token', JSON.parse(localStorage.getItem('login')).token)
        this.$http.post('/apipx/Tool/upload', formData, config).then(function (res) {
          if (res.code === 0) {
            that.answer[index].val = res.data.src[0]
            that.answer[index].key = id
          }
        })
      },
      descInput (index, id, $event) {
        this.answer[index].val = $event.target.value
        this.answer[index].key = id
      },
      addtest () {
        for (let i = 0; i < this.answer.length; i++) { // 循环第一层判断单选 多选
          if (typeof (this.answer[i].val) === 'object') {
            let arr = false
            for (let x = 0; x < this.answer[i].val.length; x++) { // 循环第二判断搜狗有值
              if (this.answer[i].val[x] !== '') {
                arr = true
              }
            }
            if (!arr) {
              this.$message({
                message: '请回答第' + (i + 1) + '题',
                type: 'error',
                duration: 2000
              })
              return false
            }
          } else {
            if (this.answer[i].val === '') {
              this.$message({
                message: '请回答第' + (i + 1) + '题',
                type: 'error',
                duration: 2000
              })
              return false
            }
          }
        }
        let materialId = this.$parent.info.material[0].id
        this.$http.post('/apipx/Lesson/addtest', {
          lesson_id: this.$parent.id,
          material_id: materialId,
          answer: this.answer,
          eject_time: this.subjects.eject_time,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '答题成功',
              type: 'success',
              duration: 2000
            })
            this.$parent.videoSub = true
            this.$parent.subjectFalse = false
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .subject {
    width: 1140px;
    height: 80%;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 10%;
    margin-left: -600px;
    border-radius: 30px;
    padding: 0 30px;

    #upload-ele {
      margin-top: 20px;
    }

    .label {
      float: left;
      margin: 0 10px;
    }

    .textarea {
      padding: 20px;
      width: 30%;
      border: 1px solid #ccc;

      textarea {
        -webkit-appearance: textarea;
        border: 0;
        width: 100%;
        height: 100px;

        &:focus {
          border: 0;
        }
      }
    }

    .content {
      overflow-x: hidden;
      overflow-y: scroll;
      height: 100%;
      position: relative;

      &::-webkit-scrollbar {
        display: none;
      }

      .sure {
        margin: 20px auto;
        border-radius: 10px;
        cursor: pointer;
        width: 200px;
        height: 40px;
        line-height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
      }
    }

    .tit {
      font-size: 20px;
      text-align: center;
      margin: 40px auto 0;
    }

    li {
      overflow: hidden;
      text-align: left;
      font-size: 16px;
      margin-top: 20px;

      .top {
        margin: 10px auto;
      }

      textarea {
        &:focus {
          border: 1px solid #ff827b;
        }
      }
    }

    .supportTbody label b {
      font-size: 14px;
      font-weight: normal;
    }

    .supportTbody label i {
      font-size: 12px;
      font-style: normal;
      display: inline-block;
      width: 13px;
      height: 13px;
      text-indent: 2px;
      line-height: 15px;
      color: #fff;
      margin: 0 5px 0 0px;
      border: #dcdfe6 1px solid;
    }

    .supportTbody input[type="radio"] + i {
      border-radius: 50%;
    }

    .supportTbody input[type="radio"]:checked + i {
      background: #fff;
      border: 1px solid #ff827b;
      position: relative;
    }

    .supportTbody input[type="radio"]:checked + i:after {
      content: '';
      width: 7px;
      height: 7px;
      position: absolute;
      top: 3px;
      left: 3px;
      background: #ff827b;
      border-radius: 50%;
    }

    .supportTbody input[type="checkbox"], .supportTbody input[type="radio"] {
      display: none;
    }

    .supportTbody input[type="checkbox"] + i {
      border-radius: 3px;
    }

    .supportTbody input[type="checkbox"]:checked + i {
      background: #ff827b;
      border: 1px solid #ff827b;
    }

    .supportTbody input[type="checkbox"]:checked ~ b {
      color: #ff827b;
    }

    .supportTbody input[type="radio"]:checked ~ b {
      color: #ff827b;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/subject/subject.vue